import { HttpClient } from '@wix/sdk-types';
import {
  GetSettingsResponse,
  GetSettingsResponseNonNullableFields,
  StartCollectingRequestsResponse,
  StartCollectingRequestsResponseNonNullableFields,
  StopCollectingRequestsResponse,
  StopCollectingRequestsResponseNonNullableFields,
  getSettings as universalGetSettings,
  startCollectingRequests as universalStartCollectingRequests,
  stopCollectingRequests as universalStopCollectingRequests,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function startCollectingRequests(
  httpClient: HttpClient
): StartCollectingRequestsSignature {
  return (appId: string) =>
    universalStartCollectingRequests(
      appId,
      // @ts-ignore
      { httpClient }
    );
}

interface StartCollectingRequestsSignature {
  /**
   * Sets `settings.collectionStates.collectingRequests` to `true` for given `appId`.
   *
   * When the collection state is set to `true`, collecting requests is enabled and customers may request
   * notifications for out of stock products. While collecting is enabled, customers see a "Notify When Available"
   * button on out-of-stock items. Customers can click the button to enter their email address, which creates the
   * notification request.
   * @param - ID of the app to start accepting notification requests for.
   */
  (appId: string): Promise<
    StartCollectingRequestsResponse &
      StartCollectingRequestsResponseNonNullableFields
  >;
}

export function stopCollectingRequests(
  httpClient: HttpClient
): StopCollectingRequestsSignature {
  return (appId: string) =>
    universalStopCollectingRequests(
      appId,
      // @ts-ignore
      { httpClient }
    );
}

interface StopCollectingRequestsSignature {
  /**
   * Sets `settings.collectionStates.collectingRequests` to `false` for given `appId`.
   *
   * When the collection state is set to `false`, collecting notification requests is disabled.
   * @param - ID of the app to stop accepting notification requests for.
   */
  (appId: string): Promise<
    StopCollectingRequestsResponse &
      StopCollectingRequestsResponseNonNullableFields
  >;
}

export function getSettings(httpClient: HttpClient): GetSettingsSignature {
  return () =>
    universalGetSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetSettingsSignature {
  /**
   * Retrieves back in stock request settings.
   */
  (): Promise<GetSettingsResponse & GetSettingsResponseNonNullableFields>;
}

export {
  BackInStockCollectionState,
  BackInStockSettings,
  GetSettingsRequest,
  GetSettingsResponse,
  GetSettingsResponseNonNullableFields,
  StartCollectingRequestsRequest,
  StartCollectingRequestsResponse,
  StartCollectingRequestsResponseNonNullableFields,
  StopCollectingRequestsRequest,
  StopCollectingRequestsResponse,
  StopCollectingRequestsResponseNonNullableFields,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';
